import { useCallback } from 'react';
import { usePage } from '@99designs/tracking';
import { useDesignLiveAvailableTimesLazyQuery } from './appointments.generated';

type AvailabilityResult = Promise<boolean | null>;

export function useConfirmDesignLiveTimeIsAvailable(
    date: string | null,
    time: string,
    timezone: string,
    calendarId?: number
): { checkAvailability: () => AvailabilityResult } {
    const { locale } = usePage();

    const [fetchTimes] = useDesignLiveAvailableTimesLazyQuery({
        fetchPolicy: 'network-only',
    });

    const checkAvailability = useCallback(async (): AvailabilityResult => {
        if (!date || !time) {
            return null;
        }

        const { data } = await fetchTimes({
            variables: {
                date,
                timezone,
                locale,
                calendarId,
            },
        });

        if (!data) {
            return null;
        }

        return data.setField.times.some((t) => t.startTimeUTC === time);
    }, [date, time, timezone, locale, calendarId, fetchTimes]);

    return { checkAvailability };
}
